<template>
    <div>
        <p class="sr-only" role="status" aria-atomic="true">{{ copied ? linkCopiedText : "" }}</p>
        <Transition name="fade" mode="out-in" appear class="[--fade-duration:100ms]">
            <StatusChip v-if="copied" state="done" :size="size" class="w-full justify-center gap-2">
                <template #leading><i class="bi bi-check-lg text-lg/none" aria-hidden="true"></i></template>
                {{ linkCopiedText }}
                <template v-if="!hideDismiss" #trailing>
                    <button type="button" class="bi bi-x-lg leading-none" aria-label="Close collaboration profile search" @click="emit('dismiss')"></button>
                </template>
            </StatusChip>
            <BaseButton v-else theme="tertiary" :size="size" class="shrink-0 gap-2 w-full" :disabled="disabled" @click="emit('copy')">
                <i class="bi bi-link-45deg" aria-hidden="true"></i>
                Copy request link
            </BaseButton>
        </Transition>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import StatusChip from "~vue/components/StatusChip.vue";

withDefaults(
    defineProps<{
        copied: boolean;
        disabled?: boolean;
        hideDismiss?: boolean;
        size?: "sm" | "md";
        linkCopiedText?: string;
    }>(),
    {
        disabled: false,
        hideDismiss: false,
        size: "md",
        linkCopiedText: "Link Copied",
    },
);

const emit = defineEmits<{
    copy: [];
    dismiss: [];
}>();
</script>
